import React, { Component } from "react";
import { Table } from 'semantic-ui-react'

export default class RadioTable extends Component{
  constructor(props) {
    super(props);
  }

  renderHeaders() {
    try {
      return(
        <Table.Row>
          <Table.HeaderCell key='fieldColumn'>{this.props.headers[0]}</Table.HeaderCell>
          {this.props.headers.slice(1).map((header, index) => (
            <Table.HeaderCell key={`column-${index}`}>{header.text}</Table.HeaderCell>
          ))}
        </Table.Row>
      )
    } catch (error) {
      console.log(error, 'invalid headers array, or not provided');
    }
  }

  handleRadioInput(rowIndex, colIndex) {
    this.props.rowDataUpdate(this.props.rows[rowIndex][1], this.props.rows[rowIndex][2], this.props.headers[colIndex].value)
  }

  renderRows() {
    try {
      return this.props.rows.map((row, rowIndex) => {
        const radios = [];
        var checkedIndex = null
        if (row[3] !== null){
          this.props.headers.slice(1).map((lookup, headerIndex) => {
            if (row[3]!==null && lookup.value === row[3]){
              checkedIndex = headerIndex + 1
            }
          })
        }
        for (let i = 1; i < this.props.headers.length; i++) {
          radios.push(
            <Table.Cell key={`radio-${rowIndex}-${i}`}>
              <input type="radio" disabled={this.props.disabled} name={`radio-${this.props.rows[rowIndex]}-${rowIndex}`} checked={i === checkedIndex} 
                     onChange={()=> {this.handleRadioInput(rowIndex, i)}} style={{transform: "scale(1.5)"}}/> 
            </Table.Cell>
          )
        }
        return (
          <Table.Row key={rowIndex}> 
            <Table.Cell>{row[0]}</Table.Cell>
            {radios}
          </Table.Row>
        );
      });
    } catch (error) {
      console.log(error, 'invalid rows array, or not provided');
    }
  }

  render() {
    return (
      <Table compact celled textAlign='center'>
        {this.renderHeaders()}
        {this.renderRows()}
      </Table>
    );
  }
}
